import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Pages } from 'core/pages';

const Dashboard = lazy(() => import('./Dashboard'));
const List = lazy(() => import('./List'));
const Create = lazy(() => import('./Create'));
const ResourcePage = lazy(() => import('./ResourcePage'));
const Versions = lazy(() => import('./Versions'));
const Update = lazy(() => import('./Update'));

export function TourRoutes() {
  return (
    <Routes>
      <Route path={Pages.sports.cricket.tour.meta.path}>
        <Route
          index
          element={(<Dashboard />)}
        />
        <Route
          path={Pages.sports.cricket.tour.list.meta.path}
          element={(<List />)}
        />
        <Route
          path={Pages.sports.cricket.tour.create.meta.path}
          element={(<Create />)}
        />
        <Route
          path={Pages.sports.cricket.tour.read.meta.path}
          element={(<ResourcePage />)}
        />
        <Route
          path={Pages.sports.cricket.tour.versions.meta.path}
          element={(<Versions />)}
        />
        <Route
          path={Pages.sports.cricket.tour.update.meta.path}
          element={(<Update />)}
        />
      </Route>
    </Routes>
  );
}
